
// Don't EDIT this file
// This is a config file generated on build
// to change values of enviroment. edit config/files.json
// enviroment: PROD

const config = {
  "apis": {
    "site": {
      "base_url": "https://api.haytek.com.br/v1.1",
      "dashboard": "/users/dashboard/<client_id>/<user_id>",
      "client_config": "/client/<client_id>/orders/config"
    },
    "basket": {
      "base_url": "https://api.haytek.com.br/api/v1/basket/v1.0",
      "basket_flow": "/client/<client_id>/flow",
      "basket_count": "/client/<client_id>/count",
      "basket": "/client/<client_id>",
      "grade": "/client/<client_id>/grade",
      "parapar": "/client/<client_id>/parapar",
      "surfacado": "/client/<client_id>/surfacado",
      "grade_details": "/client/<client_id>/grade/product/<product_id>/detail",
      "parapar_details": "/client/<client_id>/parapar/product/<product_id>/os/<order_os>/detail",
      "surfacado_details": "/client/<client_id>/surfacado/product/<product_id>/os/<order_os>/detail",
      "delete_grade_item": "/client/<client_id>/grade/product/<product_id>/payment/<payment_type>",
      "delete_grade_variation": "/client/<client_id>/grade/product/<product_id>/variation/<variation_id>",
      "delete_parapar_item": "/client/<client_id>/parapar/product/<product_id>/os/<order_os>"
    }
  },
  "urls": {
    "home": "https://haytek.com.br",
    "basket": "https://carrinho.haytek.com.br",
    "checkout": "/admin/checkout",
    "edit": "/admin/<order_type>/edicao/<product_id>/<order_os>",
    "edit_grade": "/admin/grade/edicao/<product_id>",
    "dashboard": "/admin/dashboard",
    "my_orders": "/admin/meuspedidos",
    "financial": "/admin/financeiro",
    "downloads": "/admin/downloads",
    "contact": "/admin/duvidasecontato",
    "users": "/admin/usuarios",
    "adresses": "/admin/enderecos",
    "change_password": "/admin/dashboard/trocar_senha",
    "change_company": "/admin/dashboard/trocar_empresa",
    "order_grade": "/admin/grade",
    "order_parapar": "/admin/parapar",
    "order_surfacado": "/admin/surfacado",
    "models_surfacado": "/assets/images/modelos"
  },
  "cookie": {
    "force_https": true,
    "domain": "haytek.com.br"
  },
  "feature_toggle": {
    "cookie_enabled": true,
    "force_redirect_to_home": false
  },
  "env": "prod"
}

export default config
